module.exports = __webpack_public_path__ + "20251203d193705t/img/learning-cuate-icon.044b9169.png";